// extracted by css-extract-rspack-plugin
export default {"Surface":"CopilotAppBanner-module__Surface__qrgnp"};